"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nativeContractsValidationSchemaCreator = void 0;
const yup_1 = require("yup");
const yup_rules_1 = require("@dzambalaorg/yup-rules");
const types_1 = require("../../../../../types");
const nativeContractsValidationSchemaCreator = (service) => (0, yup_1.object)().shape({
    symbol: yup_rules_1.symbolValidationSchema,
    title: yup_rules_1.titleValidationSchema,
    description: yup_rules_1.draftValidationSchema,
    ...(service === types_1.ServiceType.OFFICE && {
        merchantId: yup_rules_1.dbIdValidationSchema,
    }),
});
exports.nativeContractsValidationSchemaCreator = nativeContractsValidationSchemaCreator;
//# sourceMappingURL=validation.js.map